export default __webpack_public_path__ + "static/media/EM0100.34I-19687_-15059_0.46f3eea0.jpg";